// Direktiva na renderovanie KURZOVEJ PONUKY (prva uroven)
directives.sportsBookDirective.sportsBook = {
    compile: function(data) {
        var template = `
            ${data.map(sport => `
                <details id="${sport.Typ}${sport.ID}" class="SB-root SB-level-root sport-border-color-${sport.ID}" sport-id="${sport.ID}" region-id="${sport.RegionID}" order="${sport.Order}" ontoggle="sportsbook.on1stLevelToggle(this)">
                    <summary class="sport">
                        <span class="ui-icon-sports sport-${sport.ID} sport-icon-${sport.ID == 1 ? 'golden-league' : sport.ID}"></span>
                        <span ID="offerRoot" sport-name-full="${sport.Name}" class="offer-root">${sport.Name.length > 22 ? sport.Name.slice(0, 22) + " ..." : sport.Name}</span>
                        ${sport.EventCount > 0 ? `<span ID="sumSport" class="sum-sport">${sport.EventCount}</span>` : ''}
                    </summary>
                </details>
            `).join("")}
        `;
        return template;
    },
    // Funkcia na renderovanie kurzovej ponuky
    render: function(placeholderId, data) {
        var targetElement = document.getElementById(placeholderId);
        if (!targetElement) {
            console.error(`Element with id ${placeholderId} not found.`);
            return;
        }
        targetElement.innerHTML = this.compile(data);
        // odstranujem zakaz interakcie s ponukou po jej renderovani ktoru pridavam v main.js pri prechode na inu "stranku"
        targetElement.classList.remove("ui-disabled");
    }
};
